import CollectionPublishButton from './CollectionPublishButton.container'

export default CollectionPublishButton
